module.exports = __webpack_public_path__ + "static/media/cotyBanner-tablet-738x57@2x.c40a4c07.jpg";